// @flow

import React from 'react';
export function CampaignPlannerIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 3C12.5198 3 13.3593 3.76355 13.4824 4.75H13.75C14.9926 4.75 16 5.75736 16 7V14.75C16 15.9926 14.9926 17 13.75 17H6.25C5.00736 17 4 15.9926 4 14.75V7C4 5.75736 5.00736 4.75 6.25 4.75H6.51758C6.64072 3.76355 7.48018 3 8.5 3H11.5ZM13.2803 9.21973C12.9874 8.92683 12.5126 8.92683 12.2197 9.21973L9.25 12.1895L8.03027 10.9697C7.73738 10.6768 7.26262 10.6768 6.96973 10.9697C6.67683 11.2626 6.67683 11.7374 6.96973 12.0303L8.71973 13.7803C9.01262 14.0732 9.48738 14.0732 9.78027 13.7803L13.2803 10.2803C13.5732 9.98738 13.5732 9.51262 13.2803 9.21973ZM8.5 4.5C8.22386 4.5 8 4.72386 8 5V6C8 6.27614 8.22386 6.5 8.5 6.5H11.5C11.7761 6.5 12 6.27614 12 6V5C12 4.72386 11.7761 4.5 11.5 4.5H8.5Z" />
    </svg>
  );
}
